import axios from 'axios';
import { getAPIHost } from '@rsos/utils/metaTags';
import {
  FETCH_OAUTH_START,
  FETCH_OAUTH_SUCCESS,
  FETCH_OAUTH_ERROR,
} from './actionTypes';

const host = `${getAPIHost()}`;

const instance = axios.create({
  baseURL: `${host}`,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});

export const oAuthAction = oauthBody => dispatch => {
  dispatch({ type: FETCH_OAUTH_START });
  return instance
    .post(`/oauth/token`, oauthBody)
    .then(response => {
      return dispatch({ type: FETCH_OAUTH_SUCCESS, payload: response });
    })
    .catch(error => {
      return dispatch({ type: FETCH_OAUTH_ERROR, payload: error });
    });
};
